"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useWebChatAPIContext;

var _react = require("react");

var _WebChatAPIContext = _interopRequireDefault(require("./WebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useWebChatAPIContext() {
  var context = (0, _react.useContext)(_WebChatAPIContext.default);

  if (!context) {
    throw new Error('This hook can only be used on a component that is a descendant of <Composer>');
  }

  return context;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VXZWJDaGF0QVBJQ29udGV4dCIsImNvbnRleHQiLCJ1c2VDb250ZXh0IiwiV2ViQ2hhdEFQSUNvbnRleHQiLCJFcnJvciJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2hvb2tzL2ludGVybmFsL3VzZVdlYkNoYXRBUElDb250ZXh0LmpzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHVzZUNvbnRleHQgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCBXZWJDaGF0QVBJQ29udGV4dCBmcm9tICcuL1dlYkNoYXRBUElDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlV2ViQ2hhdEFQSUNvbnRleHQoKSB7XG4gIGNvbnN0IGNvbnRleHQgPSB1c2VDb250ZXh0KFdlYkNoYXRBUElDb250ZXh0KTtcblxuICBpZiAoIWNvbnRleHQpIHtcbiAgICB0aHJvdyBuZXcgRXJyb3IoJ1RoaXMgaG9vayBjYW4gb25seSBiZSB1c2VkIG9uIGEgY29tcG9uZW50IHRoYXQgaXMgYSBkZXNjZW5kYW50IG9mIDxDb21wb3Nlcj4nKTtcbiAgfVxuXG4gIHJldHVybiBjb250ZXh0O1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRUE7Ozs7QUFFZSxTQUFTQSxvQkFBVCxHQUFnQztFQUM3QyxJQUFNQyxPQUFPLEdBQUcsSUFBQUMsaUJBQUEsRUFBV0MsMEJBQVgsQ0FBaEI7O0VBRUEsSUFBSSxDQUFDRixPQUFMLEVBQWM7SUFDWixNQUFNLElBQUlHLEtBQUosQ0FBVSw4RUFBVixDQUFOO0VBQ0Q7O0VBRUQsT0FBT0gsT0FBUDtBQUNEIn0=